// GAVION open-pixel: Paramètres → Courriels (admins).
export const emailSettingsFr = {
  title: "Courriels",
  open_tracking: "Suivi des ouvertures",
  open_tracking_help:
    "Ajoute un pixel invisible aux courriels de séquence et un à un envoyés depuis Outlook pour savoir quand le prospect les ouvre (jamais aux confirmations de démo). Une mention l'indique au bas du courriel. Aucune adresse IP n'est conservée ; les ouvertures probablement automatiques (Apple Mail, antivirus) sont signalées.",
  open_tracking_caveat:
    "À noter : vos propres lectures du courriel envoyé (Éléments envoyés dans Outlook) et les copies citées dans une réponse ou un transfert peuvent aussi compter comme des ouvertures.",
  save: "Enregistrer",
  saved: "Paramètres des courriels enregistrés.",
};
